import { render, staticRenderFns } from "./bao-cao-xuat-hang.vue?vue&type=template&id=6acc593c&"
import script from "./bao-cao-xuat-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-xuat-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports